import React from "react";

const HomeContact = ({ home }) => {

  const contact = home[2];

  return (
    <div className="jumbotron bg-transparent px-0">
      <div className="px-0 mx-0 pl-3 pl-sm-0">
        <h2 className="text-sm-center mb-3 " data-aos="fade-in" data-aos-easing data-aos-duration="1000" data-aos-once="true">Contact</h2>
      </div>
      <section className="HomeContact container px-md-0 d-lg-flex justify-content-around">
        <div className="row row-cols-1 d-md-flex justify-content-between col-lg-9" data-aos="fade-in" data-aos-easing data-aos-duration="1000" data-aos-once="true">

          {contact.map(item => {

            const { heading, description } = item;

            return (
              <div key={contact.indexOf(item)} 
                className={`col px-0 ${(contact.indexOf(item) === 0) ? "col-md-5" : "col-md-3"} px-sm-0 col-lg-4 d-lg-flex justify-content-center`}
              >
                <div>
                <p><span className="font-weight-bold lead">{heading}</span><br />
                  {description.map(el => (
                    <span key={description.indexOf(el)} className="font-weight-light">
                      {(el === "info@accincnyc.com") 
                        ? 
                        <a href='mailto:info@accincnyc.com'>{el}</a>
                        : 
                        el
                      }<br />
                    </span>
                  ))}
                </p>
                </div>
              </div>
            )

          })}
        </div>
      </section>  
    </div>
  );
}

export default HomeContact;